{
    "roadmap": {
        "common": {
            "openAll": "Otwórz wszystkie",
            "closeAll": "Zamknij wszystkie",
            "openorCloseTitle": "Otwórz/Zamknij wszystkie akordeony"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Czym jest NextGen IT: Wprowadzenie automatyzacji IT do użytkownika końcowego i szybsze rozwiązywanie problemów.",
            "acc1Title": "W produkcji",
            "prodItem1": "Integracja artykułów KB: Ponad 300 artykułów KB umożliwiających samodzielne rozwiązywanie problemów IT",
            "prodItem2": "Rozwiązanie samonaprawiające: Ponad 18 skryptów zdalnych dostępnych do rozwiązania problemu.",
            "prodItem3": "Tworzenie incydentów: Zapewnia dokładne i szybsze rozwiązanie poprzez automatyczne rejestrowanie incydentów.",
            "prodItem4": "Czat z żywym agentem (ludzkim agentem): MyHelp pozwala użytkownikom na czat z ludzkim agentem z AI Assistant",
            "acc2Title": "W rozwoju",
            "devItem1": "Harmonogram oddzwaniania (luty - 2026): Zaplanuj oddzwonienie wsparcia IT w dogodnym dla Ciebie czasie",
            "devItem2": "Inteligentne trasowanie (luty - 2026): Przekierowanie zgłoszeń do odpowiedniego zespołu rozwiązującego dla szybszego wsparcia",
            "acc3Title": "W backlogu",
            "backItem1": "Agent rozwiązywania problemów PKI: Integracja MyHelp z agentem rozwiązywania problemów PKI w celu rozwiązania problemów związanych z certyfikatami",
            "backItem2": "Zaplanuj wizyty w centrum obsługi bezpośrednio przez MyHelp"
        },
        "corporate": {
            "title": "Korporacyjne",
            "desc": "Dział korporacyjny odpowiada za zarządzanie aplikacjami korporacyjnymi przedsiębiorstwa, platformami HR, które wspierają funkcje pracownicze i biznesowe.",
            "acc1Title": "W produkcji",
            "prodItem1": "Aplikacje oparte na BU: Ponad 90 aplikacji z personalizacją opartą na BU",
            "prodItem2": "Przypinanie aplikacji niestandardowych: Użytkownicy mogą personalizować swój Dashboard MyHelp, przypinając aplikacje niestandardowe",
            "prodItem3": "Zapytania dotyczące miejsca pracy: Ponad 100 zapytań dotyczących miejsca pracy (biuro, parking, budynki)",
            "prodItem4": "Rezerwacja sali spotkań z asystentem AI: Szybka, uproszczona rezerwacja sali spotkań z integracją Gingco",
            "prodItem5": "Zapytania HR: MyHelp odpowiada na 50 najważniejszych zapytań HR",
            "prodItem6": "Wyszukiwanie osób: Użytkownicy mogą wyszukiwać swoich kolegów z E.ON przez MyHelp",
            "acc2Title": "W rozwoju",
            "devItem1": "Onboarding aplikacji w oparciu o wdrożenie jednostki biznesowej.",
            "devItem2": "Asystent AI do sali spotkań",
            "acc3Title": "W backlogu",
            "backItem1": "Dodawanie aplikacji z asystenta AI i niestandardowych kart: Dodawanie aplikacji natychmiastowo przez sugerowane opcje asystenta MyHelp"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Ta integracja pomaga w znajdowaniu odpowiednich szkoleń i kursów.",
            "acc1Title": "W produkcji",
            "prodItem1": "Wyszukiwanie szkoleń i kursów: Znajdź odpowiednie szkolenia i kursy za pomocą MyHelp",
            "acc2Title": "W rozwoju",
            "acc3Title": "W backlogu",
            "backItem1": "Personalizowane uczenie się: Personalizowane rekomendacje szkoleniowe w oparciu o kwalifikacje jednostki biznesowej."
        },
        "myItOrder": {
            "title": "Zamówienie MyIT",
            "desc": "Ta integracja pomaga w znajdowaniu odpowiednich przedmiotów zamówień IT i katalogów.",
            "acc1Title": "W produkcji",
            "prodItem1": "Szybkie wyszukiwanie katalogu zamówień IT: Szybkie wyszukiwanie i zamawianie IT z MyHelp",
            "prodItem2": "Włączanie i odwoływanie dostępu do oprogramowania: Włącz lub odwołaj dostęp do oprogramowania, nawigując z MyHelp.",
            "acc2Title": "W rozwoju",
            "devItem1": "Przegląd kosztów aktywów IT: MyHelp wyświetli przegląd kosztów Twoich aktywów IT",
            "acc3Title": "W backlogu",
            "backItem1": "Centralna akceptacja zamówionych przedmiotów"
        },
        "compass": {
            "title": "Kompas",
            "desc": "Ta integracja pomoże Ci znaleźć społeczność, informacje o wiadomościach i ogłoszeniach udostępnianych w intranecie.",
            "acc1Title": "W produkcji",
            "prodItem1": "Do wydania do 28 lutego 2026",
            "acc2Title": "W rozwoju",
            "devItem1": "Wyszukiwanie Compass (luty – 2026): Użytkownicy E.ON będą mogli wyszukiwać dane społeczności w MyHelp E.ON Search",
            "devItem2": "Asystent AI MyHelp-Compass (w trakcie realizacji) (luty – 2026): Umożliwienie użytkownikom E.ON dostępu do danych społeczności przez asystenta AI MyHelp",
            "acc3Title": "W backlogu"
        },
        "chatProjectData": {
            "title": "Czat z danymi projektowymi",
            "desc": "Ta integracja pozwala na onboardowanie danych projektowych z confluence, sharepoint itp.",
            "acc1Title": "W produkcji",
            "prodItem1": "Projekty Confluence One Billing i DSODP są onboardowane",
            "prodItem2": "Witryny SharePoint – witryna projektu DSODP jest onboardowana",
            "acc2Title": "W rozwoju",
            "devItem1": "Prace nad integracją danych projektu Nautilus są obecnie w toku.",
            "acc3Title": "W backlogu"
        },
        "personalization": {
            "title": "Personalizacja",
            "acc1Title": "W produkcji",
            "prodItem1": "Wielojęzyczność: obsługuje 4 języki (angielski, niemiecki, szwedzki, rumuński)",
            "prodItem2": "Wielotematyczność: pozwala każdej jednostce biznesowej lub regionowi używać własnej marki, poprawiając znajomość i przyjęcie.",
            "prodItem3": "5 dodatkowych nowych języków w profilu beta (czeski, włoski, węgierski, niderlandzki i polski)",
            "acc2Title": "W rozwoju",
            "devItem1": "Specyficzne dla źródła danych: (15 lutego – 2026): zapewnia bardziej ukierunkowane i świadome kontekstu odpowiedzi, pobierając informacje z wybranych przez użytkownika źródeł danych.",
            "acc3Title": "W backlogu"
        },
        "technicalEnablement": {
            "title": "Techniczne umożliwienie",
            "acc1Title": "W produkcji",
            "prodItem1": "Bezpieczeństwo i obserwowalność zapewniają ochronę danych na poziomie przedsiębiorstwa, zgodność i wydajność, a także umożliwiają bezpieczne, niezawodne i płynne działanie operacji",
            "prodItem2": "Dashboardy KPI i adopcji (Power BI)<br /> Zapewniają jasną widoczność użycia, realizacji wartości i wpływu biznesowego poprzez dashboardy KPI",
            "acc2Title": "W rozwoju",
            "devItem1": "Przepływ pracy multiagentowy do 15 marca 2026: Umożliwia bardziej intencjonalne rozmowy, które nie tylko poprawiają trafność odpowiedzi, ale także wykonują end-to-end dla użytkowników.",
            "acc3Title": "W backlogu",
            "backItem1": "Framework MCP (Backlog): <br /> Zapewnia podstawę do orkiestracji i koordynacji agentów AI w E.ON, umożliwiając skalowalne i współpracujące możliwości AI w przedsiębiorstwie."
        }
    }
}